import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  signal,
} from "@angular/core";

@Component({
  selector: "app-paginations",
  templateUrl: "./paginations.component.html",
  styleUrl: "./paginations.component.scss",
  standalone: false,
})
export class PaginationsComponent {
  @Input()
  set dataSource(value: any) {
    if (value) {
      this.sources = value;
      this.total_page = Array(value.total_page || value.length).fill(0);
    }
  }

  @Input() set isLoading(value: boolean) {
    this.loading.update((_) => value);
  }

  @Output() onPageChange = new EventEmitter();

  sources: any;

  /**
   * The last row number actually on screen.
   *
   * The template used `offset + limit`, which is the page SIZE, not the number
   * of rows on the page — so two orders under a limit of ten announced
   * "แสดง 1 - 10 จากทั้งหมด 2 รายการ". The count has to be clamped to the total.
   */
  get endValue(): number {
    const offset = Number(this.sources?.offset) || 0;
    const total = Number(this.sources?.total) || 0;
    const limit = Number(this.sources?.limit) || total;
    return Math.min(offset + limit, total);
  }

  /** …and the first row, which is 0 rather than 1 when there is nothing. */
  get startValue(): number {
    const total = Number(this.sources?.total) || 0;
    if (!total) return 0;
    return (Number(this.sources?.offset) || 0) + 1;
  }
  total_page: any;

  current_page = 1;
  current_loop = 1;
  max_page = 5;
  min_page = 1;

  loading = signal(true);

  #cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.max_page = this.sources.page + 4;
    this.min_page = this.sources.page;
    this.current_loop = this.sources.page;
    this.current_page = this.sources.page;
  }

  pageChange(page: number) {
    const current_page = this.sources.page;
    const next_page = page;
    if (next_page <= 0 || next_page > this.sources.total_page) {
      return;
    }
    if (page > current_page && page > this.current_loop + 4) {
      if (current_page < page) {
        this.sources.page = page;
        setTimeout(() => {
          this.max_page += next_page - current_page;
          this.min_page += next_page - current_page;
        }, 10);
      } else {
        this.sources.page = page;
        if (page === this.min_page) {
          setTimeout(() => {
            this.max_page = this.max_page - 1;
            this.min_page = this.min_page - 1;
            this.current_loop = this.min_page;
          }, 10);
        } else {
        }
      }
      setTimeout(() => {
        this.#cdr.detectChanges();
      }, 120);
    } else if (page < current_page && page < this.min_page) {
      this.sources.page = page;

      setTimeout(() => {
        this.max_page = this.max_page - 1;
        this.min_page = this.min_page - 1;
        this.current_loop = this.min_page;
      }, 10);
      setTimeout(() => {
        this.#cdr.detectChanges();
      }, 120);
    } else {
      this.sources.page = page;
    }

    this.onPageChange.emit({ page: page });
  }

  isDivisibleBy(divide_by: number, num: number): boolean {
    return num % divide_by === 0;
  }

  isDivisible(divide_by: number, num: number) {
    return num % 5;
  }
}
